import { JobStatusEnum, JobStatusSchema } from '@eigtech/restoration-types'
import { startCase } from 'lodash-es'

const partialJobStatusLabels: Partial<Record<JobStatusEnum, string>> = {}

export const getJobStatusLabel = (status: JobStatusEnum) =>
  partialJobStatusLabels[status] ?? startCase(status)

export const jobStatusLabels = Object.fromEntries(
  JobStatusSchema.options.map((key) => [key, getJobStatusLabel(key)])
) as Record<JobStatusEnum, string>
